import axios from 'axios'
import { LoggedInUser } from '../../slices/authSlice'
import { setContactFilterType } from '../../slices/contactAddressSlice'

export const getAPILoggedInUser = async () => {
  const { data } = await axios.get<LoggedInUser>(
    `${process.env.REACT_APP_API_URL}/user`,
    {
      withCredentials: true,
    },
  )

  // console.log(`loggedInUser.ts getAPILoggedInUser() currContacts changed. data=${JSON.stringify(data)}`)
  setContactFilterType((data.role !== 4 ? 'all' : 'personal'))
  return data
}
